import axios from 'axios'
import {
        FETCH_UNIVERSELIST_BEGIN,
        FETCH_UNIVERSELIST_SUCCESS,
        FETCH_UNIVERSELIST_FAILURE
    } from '../constants/universeList'
import { getUniverseList } from '../../config/apiConfig';
import { sbaAxios } from '../utils/sbaAxios';

export const getUniverseListAction=()=>{
    return (dispatch) => {
        dispatch(fetchUniverseListsBegin());
        sbaAxios({url:`${getUniverseList}`,method:'get'}).then((reponse) => {
          const UniverseList = reponse;
          dispatch(fetchAssetListSuccess(UniverseList));
          return UniverseList;
        })
        .catch((error) => {return dispatch(fetchAssetListFailure(error))});
      };
}

export const fetchUniverseListsBegin = () => ({
    type: FETCH_UNIVERSELIST_BEGIN,
  });
  
  export const fetchAssetListSuccess = (UniverseList) => ({
    type: FETCH_UNIVERSELIST_SUCCESS,
    payload: {UniverseList},
  });
  
  
  export const fetchAssetListFailure = (errorMessage) => ({
    type: FETCH_UNIVERSELIST_FAILURE,
    payload: {errorMessage}
  });
  
  